<template>
    <div id="academy-container" class="academy-container">
        <ul class="v-breadcrumbs vindome-breadcrumbs">
            <li class="v-breadcrumbs__item__home">
                <nuxt-link :to="localePath('/')" class="v-breadcrumbs__item">Vindome</nuxt-link>
            </li>
            <li class="v-breadcrumbs__divider">&gt;</li>
            <li>
                <span class="v-breadcrumbs__item">{{ $t("main-menu12") }}</span>
            </li>
        </ul>
        <div class="wine-guide-head">
            <div class="container">
                <h1 class="inner-page-title">{{ $t('wine-academy1') }}</h1>
                <div class="how-subheading">{{ $t('wine-academy2') }}</div>
            </div>
        </div>

        <section id="investment-guide" class="wine-invest">
            <div class="container1366 padding200 padding80">
                <h2>{{ $t('wine-academy3') }}</h2>
                <div class="title-border"></div>

                <div class="wine-invest-content">
                    <div class="wine-invest-title">{{ $t('wine-academy4') }}</div>

                    <v-expansion-panels class="wine-invest-accordion">
                        <v-expansion-panel class="wine-expansion-panel wine-expansion-panel1">
                            <v-expansion-panel-header>
                                <div class="wine-invest-head wine-invest-head1">
                                    {{ $t('wine-academy5') }}
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="wine-invest-panel-content">
                                    {{ $t('wine-academy6') }}
                                    <ul>
                                        <li>{{ $t('wine-academy7') }}</li>
                                        <li>{{ $t('wine-academy8') }}</li>
                                        <li>{{ $t('wine-academy9') }}</li>
                                        <li>{{ $t('wine-academy10') }}</li>
                                    </ul>
                                    {{ $t('wine-academy11') }}
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel class="wine-expansion-panel wine-expansion-panel2">
                            <v-expansion-panel-header>
                                <div class="wine-invest-head wine-invest-head2">
                                    {{ $t('wine-academy12') }}
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="wine-invest-panel-content">
                                    {{ $t('wine-academy13') }}
                                    <br/><br/>
                                    {{ $t('wine-academy14') }}
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel class="wine-expansion-panel wine-expansion-panel3">
                            <v-expansion-panel-header>
                                <div class="wine-invest-head wine-invest-head3">
                                    {{ $t('wine-academy15') }}
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="wine-invest-panel-content">
                                    {{ $t('wine-academy16') }}
                                    <br/><br/>
                                    {{ $t('wine-academy17') }}
                                    <br/><br/>
                                    {{ $t('wine-academy18') }}
                                    <br/><br/>
                                    {{ $t('wine-academy19') }}

                                    <div class="table-info">{{ $t('tips10') }}</div>
                                    <div class="table-head">
                                        <div class="table-left">{{ $t('tips11') }}</div>
                                        <div class="table-right">{{ $t('tips12') }}</div>
                                    </div>
                                    <div class="table-body">
                                        <div class="table-row">
                                            <div class="table-left">95-100</div>
                                            <div class="table-right">{{ $t('tips13') }}</div>
                                        </div>
                                        <div class="table-row">
                                            <div class="table-left">90–94</div>
                                            <div class="table-right">{{ $t('tips14') }}</div>
                                        </div>
                                        <div class="table-row">
                                            <div class="table-left">85–89</div>
                                            <div class="table-right">{{ $t('tips15') }}</div>
                                        </div>
                                        <div class="table-row">
                                            <div class="table-left">80–84</div>
                                            <div class="table-right">{{ $t('tips16') }}</div>
                                        </div>
                                        <div class="table-row">
                                            <div class="table-left">75–79</div>
                                            <div class="table-right">{{ $t('tips17') }}</div>
                                        </div>
                                        <div class="table-row">
                                            <div class="table-left">50–74</div>
                                            <div class="table-right">{{ $t('tips18') }}</div>
                                        </div>
                                    </div>
                                    <i>{{ $t('tips18-1') }}</i>

                                    <div class="table-info">{{ $t('tips19') }}</div>
                                    <div class="table-head">
                                        <div class="table-left">{{ $t('tips11') }}</div>
                                        <div class="table-right">{{ $t('tips12') }}</div>
                                    </div>
                                    <div class="table-body">
                                        <div class="table-row">
                                            <div class="table-left">20</div>
                                            <div class="table-right">{{ $t('tips20') }}</div>
                                        </div>
                                        <div class="table-row">
                                            <div class="table-left">19</div>
                                            <div class="table-right">{{ $t('tips21') }}</div>
                                        </div>
                                        <div class="table-row">
                                            <div class="table-left">18</div>
                                            <div class="table-right">{{ $t('tips22') }}</div>
                                        </div>
                                        <div class="table-row">
                                            <div class="table-left">17</div>
                                            <div class="table-right">{{ $t('tips23') }}</div>
                                        </div>
                                        <div class="table-row">
                                            <div class="table-left">16</div>
                                            <div class="table-right">{{ $t('tips24') }}</div>
                                        </div>
                                        <div class="table-row">
                                            <div class="table-left">15</div>
                                            <div class="table-right">{{ $t('tips25') }}</div>
                                        </div>
                                        <div class="table-row">
                                            <div class="table-left">14</div>
                                            <div class="table-right">{{ $t('tips26') }}</div>
                                        </div>
                                        <div class="table-row">
                                            <div class="table-left">13</div>
                                            <div class="table-right">{{ $t('tips27') }}</div>
                                        </div>
                                        <div class="table-row">
                                            <div class="table-left">12</div>
                                            <div class="table-right">{{ $t('tips28') }}</div>
                                        </div>
                                    </div>
                                    <br/><br/>
                                    {{ $t('tips29') }}
                                    <br/><br/>
                                    <strong>WA</strong> = {{ $t('wine-academy20') }}<br/>
                                    <strong>JS</strong> = {{ $t('wine-academy21') }}<br/>
                                    <strong>JR</strong> = {{ $t('wine-academy22') }}<br/>
                                    <strong>WS</strong> = {{ $t('wine-academy23') }}<br/>
                                    <strong>AG</strong> = {{ $t('wine-academy24') }}
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel class="wine-expansion-panel wine-expansion-panel4">
                            <v-expansion-panel-header>
                                <div class="wine-invest-head wine-invest-head4">
                                    {{ $t('wine-academy25') }}
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="wine-invest-panel-content">
                                    {{ $t('wine-academy26') }}
                                    <br/><br/>
                                    {{ $t('wine-academy27') }}
                                    <br/><br/>
                                    {{ $t('wine-academy28') }}
                                    <br/><br/>
                                    {{ $t('wine-academy29') }}<br/>
                                    {{ $t('wine-academy30') }} <strong>{{ $t('wine-academy31') }}</strong><br/>
                                    {{ $t('wine-academy32') }} <strong>{{ $t('wine-academy33') }}</strong><br/>
                                    {{ $t('wine-academy34') }} <strong>{{ $t('wine-academy35') }}</strong>
                                    <br/><br/>
                                    {{ $t('wine-academy36') }}
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel class="wine-expansion-panel wine-expansion-panel5">
                            <v-expansion-panel-header>
                                <div class="wine-invest-head wine-invest-head5">
                                    {{ $t('wine-academy37') }}
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="wine-invest-panel-content">
                                    {{ $t('wine-academy38') }}
                                    <br/><br/>
                                    {{ $t('wine-academy39') }}
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel class="wine-expansion-panel wine-expansion-panel6">
                            <v-expansion-panel-header>
                                <div class="wine-invest-head wine-invest-head6">
                                    {{ $t('wine-academy40') }}
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="wine-invest-panel-content">
                                    {{ $t('wine-academy41') }}
                                    <ul>
                                        <li>{{ $t('wine-academy42') }}</li>
                                        <li>{{ $t('wine-academy43') }}</li>
                                        <li>{{ $t('wine-academy44') }}</li>
                                        <li>{{ $t('wine-academy45') }}</li>
                                    </ul>
                                    {{ $t('wine-academy46') }}
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
                <div v-if="!isLogged" v-on:click="() => { bookChat = true }"
                     :class="$i18n.locale.toLowerCase() === 'de' || $i18n.locale.toLowerCase() === 'it' || $i18n.locale.toLowerCase() === 'fr' ? 'blue-btn center marginTop16 marginTop16Long-de center-btn' : 'blue-btn center marginTop16 marginTop16Long center-btn'">
                    {{ $t("howitworks15") }}
                </div>
                <div v-else v-on:click="showPrivacy"
                     :class="$i18n.locale.toLowerCase() === 'de' || $i18n.locale.toLowerCase() === 'it' || $i18n.locale.toLowerCase() === 'fr' ? 'blue-btn center marginTop16 marginTop16Long-de center-btn' : 'blue-btn center marginTop16 marginTop16Long center-btn'">
                    {{ $t("howitworks15") }}
                </div>
            </div>
        </section>

        <section id="wine-guide" class="wine-guide">
            <div class="container1366 padding200 padding80">
                <h2>{{ $t('wine-academy47') }}</h2>
                <div class="title-border"></div>

                <div class="wine-guide-content">
                    <div class="wine-invest-title">{{ $t('wine-academy4-1') }}</div>
                    <div class="wine-guide-mobile"></div>
                    <div class="wine-guide-left">
                        <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina')">Argentina
                        </nuxt-link>
                        <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/australia')">Australia
                        </nuxt-link>
                        <nuxt-link class="wine-guide-country"
                                   :to="localePath('/wine-guide/chile')">Chile
                        </nuxt-link>
                        <nuxt-link class="wine-guide-country"
                                   :to="localePath('/wine-guide/france')">France
                        </nuxt-link>
                        <nuxt-link class="wine-guide-country"
                                   :to="localePath('/wine-guide/germany')">Germany
                        </nuxt-link>
                        <nuxt-link class="wine-guide-country"
                                   :to="localePath('/wine-guide/italy')">Italy
                        </nuxt-link>
                        <nuxt-link class="wine-guide-country"
                                   :to="localePath('/wine-guide/new-zealand')">New Zealand
                        </nuxt-link>
                        <nuxt-link class="wine-guide-country"
                                   :to="localePath('/wine-guide/portugal')">Portugal
                        </nuxt-link>
                        <nuxt-link class="wine-guide-country"
                                   :to="localePath('/wine-guide/south-africa')">South Africa
                        </nuxt-link>
                        <nuxt-link class="wine-guide-country"
                                   :to="localePath('/wine-guide/spain')">Spain
                        </nuxt-link>
                        <nuxt-link class="wine-guide-country"
                                   :to="localePath('/wine-guide/usa')">USA
                        </nuxt-link>
                    </div>
                    <div class="wine-guide-right"></div>
                </div>
            </div>
        </section>

        <section id="news-and-articles" class="news-and-articles" v-if="blogPosts.length">
            <h2>{{ $t('wine-academy48') }}</h2>
            <div class="title-border"></div>
            <div class="news-wrapper">
                <div class="container1366 padding200">
                    <vueper-slides class="no-shadow news-articles-carousel"
                                   :touchable="false"
                                   :gap="0"
                                   :arrows="true"
                                   :visible-slides="mobileCheck ? 1 : 1.3"
                                   :fixed-height="mobileCheck ? '450px' : '420px'">
                        <vueper-slide v-for="(slide, i) in blogPosts" :key="i">
                            <template #content>
                                <div class="vueperslide__content-wrapper blog-img-layer">
                                    <div class="slide-bg" :style="getImgUrl(slide.img)"></div>
                                    <div class="news-carousel-text-wrapper">
                                        <div class="news__title">{{ slide.title }}</div>
                                        <div class="news__content">{{ slide.subtitle }}</div>
                                        <div style="z-index: 100">
                                            <a :href="slide.link" target="_blank"
                                               class="news__button">{{ $t("wine-academy49") }}</a>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </vueper-slide>
                    </vueper-slides>
                </div>
            </div>
        </section>

        <section id="portfolio-performance" class="pp-wrapper">
            <div class="container1366 padding200 padding80">
                <h2>{{ $t('wine-academy50') }}</h2>
                <div class="title-border"></div>
                <div class="pp-text">
                    {{ $t('wine-academy51') }}
                </div>
                <div class="pp-img"></div>
            </div>
        </section>

        <section id="talk-to-expert" class="academy-expert-wrapper">
            <div class="container1366 padding200" v-if="!mobileCheck">
                <div class="home-section10-title">{{ $t('wine-academy52') }}</div>
                <div class="home-section10-subtitle">
                    {{ $t('wine-academy53') }}
                </div>
                <div class="home-section10-btn-wrapper center">
                    <div v-on:click="() => { bookExpert = true }" class="home-section2-btn1 btn-white">{{ $t("new-home48") }}</div>
                    <nuxt-link :to="localePath(isLogged ? '/trading-desk' : '/register')" class="home-section2-btn2 border-white ga4-reg-btn">{{ $t("new-home3") }}</nuxt-link>
                </div>
            </div>
            <div class="container1366 padding200" v-else>
                <h2 class="home-section10-title">{{ $t('howitworks45') }}</h2>
                <div class="home-section10-subtitle">
                    {{ $t('howitworks46') }}
                </div>
                <div class="home-section10-btn-wrapper center">
                    <div v-on:click="() => { bookExpert = true }" class="home-section2-btn1 btn-white">{{ $t("new-home48") }}</div>
                    <nuxt-link v-if="isLogged" :to="localePath('/trading-desk')" class="home-section2-btn2 border-white">{{ $t('new-home3') }}</nuxt-link>
                    <nuxt-link v-else :to="localePath('/register')" class="home-section2-btn2 border-white ga4-reg-btn">{{ $t('new-home3') }}</nuxt-link>
                </div>
            </div>
        </section>

        <v-dialog v-model="bookExpert" persistent max-width="800px">
            <v-card class="qr-popup expert-popup">
                <div class="qr-close" v-on:click="() => { bookExpert = false }"></div>
                <iframe :src="iframeUrl"/>
            </v-card>
        </v-dialog>

        <v-dialog v-model="bookChat" persistent :max-width="nextStep ? '517px' : '817px'">
            <v-card :class="{'qr-popup zoho-popup': !nextStep, 'qr-popup zoho-popup2': nextStep, 'qr-popup-long': $i18n.locale !== 'en' }">
                <div class="qr-close" v-on:click="hideChat"></div>
                <div class="guide-content" v-if="!nextStep">
                    <div class="guide-reg-wrapper">
                        <div class="guide-title">{{ $t('guide1') }}</div>
                        <div class="guide-subtitle">{{ $t('guide2') }}</div>
                        <div class="mobile-back"></div>
                        <div class="reg-container">
                            <v-flex>
                                <span class="login-label">{{ $t('myprofile1') }} *</span>
                                <v-text-field
                                    id="regFName"
                                    ref="regFName"
                                    v-model="regFName"
                                    class="email-input"
                                    :rules="[rules.required]"
                                    :error="$v.regFName.$error"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <span class="login-label">{{ $t('myprofile2') }} *</span>
                                <v-text-field
                                    v-model="regLName"
                                    class="email-input"
                                    :rules="[rules.required]"
                                    :error="$v.regLName.$error"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <span class="login-label">Email *</span>
                                <v-text-field
                                    ref="email"
                                    v-model="regEmail"
                                    class="email-input"
                                    :rules="[rules.required, rules.emailValid]"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <span class="login-label">Password *</span>
                                <v-text-field
                                    ref="regPassword"
                                    v-model="regPassword"
                                    :append-icon="secureRegPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.min]"
                                    :type="secureRegPassword ? 'password' : 'text'"
                                    name="input-10-1"
                                    hint="At least 8 characters"
                                    counter
                                    @click:append="secureRegPassword = !secureRegPassword"
                                    v-on:keyup.enter="registration"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-checkbox
                                v-model="checked18"
                                :label="$t('register-confirm18')"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="checkedTerms"
                                class="check-terms"
                            >
                                <div slot="label">
                                    {{ $t('register-terms') }}
                                </div>
                            </v-checkbox>
                            <v-checkbox
                                v-model="checkedNews"
                                :label="$t('register-news')"
                                class="check-terms"
                            ></v-checkbox>
                            <v-flex>
                                <div class="errors-container2" v-if="errorMsg !== ''">
                                    <p>{{ errorMsg }}</p>
                                </div>
                            </v-flex>
                            <v-flex>
                                <v-btn class="submit login-submit" v-on:click="registration">{{ $t('guide3') }}</v-btn>
                            </v-flex>
                        </div>
                    </div>
                </div>
                <div class="login-inner-container" v-else>
                    <div class="login-success">
                        <h2>Account created successfully</h2>
                        <div class="additional-info">
                            Check your email for an account activation link!
                        </div>
                    </div>

                    <div class="login-success-btn-wrapper">
                        <v-btn class="btn-primary btn-bid-proceed" v-on:click="goToLogin">OK</v-btn>
                        <v-btn class="btn-bid-cancel" v-on:click="resendMail">Resend email</v-btn>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {VueperSlides, VueperSlide} from 'vueperslides'
import {email, minLength, required} from "vuelidate/lib/validators";
import {mapActions, mapGetters} from "vuex";
import {AAuth} from "@/store/actions";
import axios from "axios";
import {GCommon, GUser} from "@/store/getters";

export default {
    name: "WineAcademy",
    head: {
        title: 'Wine academy | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'how-it-works trading-desk inner-page wine-academy-page'
        }
    },
    validations: {
        regFName: {
            required
        },
        regLName: {
            required
        },
        regEmail: {
            required,
            email
        },
        regPassword: {
            required,
            minLength: minLength(8)
        }
    },
    components: {
        VueperSlides,
        VueperSlide,
    },
    computed: {
        ...mapGetters({
            mobileCheck: GCommon.GET_MOBILE_VERSION,
            isLogged: GUser.GET_USER_LOGGED
        }),
        iframeUrl() {
            let _url = 'https://forms.zohopublic.eu/vindome/form/EnPrimeurDailyReportSignUp/formperma/ntcZNvLn1UQbFDUQxMZ1z4tDZ8IphnwlGm1J3D24ZiA'

            if (this.$i18n.locale === 'it') {
                _url = 'https://forms.zohopublic.eu/vindome/form/TalktoaWineInvestmentExpertIT/formperma/L5S7SjLQAzMpTYdmRJpE13XLNIR8PfBut-0BM2T0hM4?zf_lang=it'
            } else if (this.$i18n.locale === 'de') {
                _url = 'https://forms.zohopublic.eu/vindome/form/TalktoaWineInvestmentExpertGermany/formperma/mppI-WpFHLAX4-dkKCvW1_v0W-mGwfpVDSAMKnSDmt8?zf_lang=de'
            } else if (this.$i18n.locale === 'fr') {
                _url = 'https://forms.zohopublic.eu/vindome/form/TalktoaWineInvestmentExpert/formperma/XW6QTfH62YOljh7kD80CWJiQ2YMlaV2opC2pERi4WnA?zf_lang=fr'
            }

            return _url
        }
    },
    data() {
        return {
            isBrowser: false,
            bookChat: false,
            bookExpert: false,
            blogPosts: [],
            regEmail: '',
            regPassword: '',
            regFName: '',
            regLName: '',
            countryId: 224,
            isLoading: false,
            checkedTerms: false,
            checked18: false,
            checkedNews: true,
            secureRegPassword: true,
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            rules: {
                required: value => !!value || 'Required.',
                min: value => value.length >= 8 || 'Min 8 characters',
                emailValid: value => this.isEmailValid(value) || 'Invalid email'
            },
            errorMsg: '',
            nextStep: false
        }
    },
    methods: {
        getImgUrl(imgUrl) {
            return "background-image: url('" + imgUrl + "')"
        },
        hideChat() {
            this.bookChat = false;
        },
        showPrivacy: function () {
            window.open('https://vindome.net/VindomeWineInvestmentGuide.pdf');
        },
        isEmailValid(email) {
            return this.reg.test(email)
        },
        goToLogin() {
            this.$router.push(this.localePath({path: '/login'}));
        },
        resendMail() {
            this.sendMail(this.regEmail)
        },
        registration() {
            this.$v.regFName.$touch();
            this.$v.regLName.$touch();
            if (this.regEmail && this.regPassword && !this.$v.regEmail.$invalid && !this.$v.regPassword.$invalid && !this.$v.regFName.$invalid && !this.$v.regLName.$invalid) {
                if (this.checkedTerms && this.checked18) {
                    this.isLoading = true;
                    let payload = {
                        email: this.regEmail,
                        password: this.regPassword,
                        confirmPassword: this.regPassword,
                        firstname: this.regFName,
                        lastname: this.regLName,
                        countryId: this.countryId,
                        phoneNumber: '',
                        name: '',
                        enabledNotification: this.enabledNotification === true ? 1 : 0,
                        newsletter: this.checkedNews
                    };
                    this.signup(payload).then(res => {
                        if (res.reasonPhrase === "Created") {
                            this.nextStep = true;
                        }

                        this.$gtm.push({ event: "registration" });
                        window.fbq('track', 'CompleteRegistration');
                        window.uetq = window.uetq || [];
                        window.uetq.push("event", "signup", {});
                        this.$gtm.push({
                            'event': 'UETRegistration',
                            'ecomm_pagetype': 'conversion'
                        });
                    }).catch(err => {
                        this.isLoading = false;
                        if (err.data.errors) {
                            if (err.data.errors.Email.length) {
                                err.data.errors.Email.forEach(err => {
                                    this.errorMsg = err;
                                })
                            } else if (err.data.errors.GeneralError.length) {
                                err.data.errors.GeneralError.forEach(err => {
                                    this.errorMsg = err;
                                })
                            } else {
                                this.errorMsg = 'Unexpected behavior. Please check your internet connection or try again later.';
                            }
                        }
                    })
                } else {
                    this.errorMsg = 'You must agree with the terms of service and confirm that you are at least 18 years old.';
                }
            } else {
                this.errorMsg = 'Please fill the above information.';
            }

        },
        ...mapActions({
            signup: AAuth.REG_USER,
            sendMail: AAuth.SEND_MAIL
        })
    },
    created () {
        axios.get('https://blog.vindome.net/wp-json/wp/v2/posts?per_page=5').then((response) => {
            response.data.forEach(blog => {
                let _newBlogPost = {};
                _newBlogPost.title = blog.yoast_head_json.title.replace(' - Vindome Blog', '');
                _newBlogPost.subtitle = blog.yoast_head_json.description;
                _newBlogPost.link = blog.link;
                _newBlogPost.img = blog.jetpack_featured_media_url;

                this.blogPosts.push(_newBlogPost)
            })
        });
    },
    mounted() {
        this.$nuxt.$on('goToSection', (sectionName) => {
            if (window) {
                const element = document.getElementById(sectionName);
                element.scrollIntoView({behavior: 'smooth'});
            }
        });
    }

}
</script>

<style scoped>
.errors-container2 {
    height: auto;
    width: 100%;
    background: transparent;
    margin: 0;
}

.errors-container2 p {
    color: #D75353;
    line-height: 12px;
    font-size: var(--fs-small);
    padding-left: 0;
    margin-bottom: 0;
    padding-top: 5;
}

.login-success {
    background: url("../assets/how/ok.gif") no-repeat center top;
    background-size: 250px;
    padding-top: 280px;
}

.qr-popup.v-card {
    border-radius: 24px;
    height: 421px;
}

.qr-popup.v-card.zoho-popup {
    height: 556px;
    width: 817px;
    overflow: hidden;
    background: #fff url("../assets/how/guide2.png") no-repeat right top;
    background-position-x: 422px;
    padding-bottom: 0;
}
.qr-popup.v-card.zoho-popup.qr-popup-long {
    height: 585px;
}

.qr-popup.v-card.zoho-popup2 {
    height: 506px;
    width: 517px;
    overflow: hidden;
    background: #f4f4f4;
    padding-bottom: 0;
}

.guide-content {
    height: 100%;
    padding: 24px;
    background: url("../assets/how/guide1.png") no-repeat right bottom;
    background-size: 510px;
}
.mobile-back {
    display: none;
}
.login-inner-container {
    height: 100%;
    padding: 24px;
}

.login-success-btn-wrapper {
    text-align: center;
}

.theme--light.v-btn.v-btn--has-bg.btn-bid-proceed {
    background: #004F7F;
    border-color: #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
    margin-right: 16px;
}

.theme--light.v-btn.v-btn--has-bg.btn-bid-cancel {
    border: 1px solid #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #004F7F;
}

.additional-info {
    text-align: center;
    margin: 32px auto;
}

.guide-reg-wrapper {
    width: 382px;
}

.guide-title {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #002840;
    margin-bottom: 8px;
}

.guide-subtitle {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #002840;
}

.qr-close {
    position: absolute;
    z-index: 1;
    top: 16px;
    right: 16px;
    width: 40px;
    height: 40px;
    border-radius: 55%;
    background: url("../assets/icon-close.svg") no-repeat center;
}

.qr-close:hover {
    background-color: #f1e2c4;
    cursor: pointer;
}

.zoho-iframe {
    width: 100%;
    min-height: 500px;
    padding: 12px 12px 0;
    border: 0;
}

.slide-bg {
    height: 240px;
    background-size: cover;
    background-position: center;
    width: 100%;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

.blue-btn {
    padding: 8px 16px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    color: #ffffff;
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    text-decoration: none;
    margin-top: 24px;
}

.blue-btn:hover {
    cursor: pointer;
}

.marginTop16 {
    margin: 16px auto 0;
    display: block;
    width: 140px;
}

.marginTop16Long {
    min-width: 240px;
}

.marginTop16Long-de {
    min-width: 320px;
}

.academy-container {
    background: #ffffff;
}

h1 {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 44px;
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 16px;
}

h2 {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #002840;
    text-align: center;
}

h3 {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #002840;
    margin-bottom: 8px;
}

.wine-guide-head {
    background: url('../assets/academy.png') no-repeat center center;
    height: 300px;
    background-size: cover;
    margin-top: 80px;
    position: relative;
}

.wine-guide-head .inner-page-title {
    padding-top: 107px;
    z-index: 2;
    position: relative;
}

.wine-guide-head .how-subheading {
    text-align: center;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #FFFFFF;
    z-index: 2;
    position: relative;
}

.container {
    position: relative;
    max-width: 1170px;
    margin: 0 auto;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1;
}

.container1366 {
    position: relative;
    max-width: 1366px;
    margin: 0 auto;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1;
}

.padding200 {
    padding: 0 200px;
}

.padding80 {
    padding-top: 80px;
    padding-bottom: 80px;
}

.title-border {
    width: 64px;
    height: 4px;
    background: #ECD9A7;
    margin: 24px auto 40px;
}

.center {
    text-align: center;
}

.home-left-50,
.home-right-50 {
    display: inline-block;
    width: calc((100% - 24px) / 2);
    height: 100%;
    vertical-align: top;
}

.home-left-50 {
    margin-right: 20px;
}

.wine-guide {
    background: #f7f7f7;
}
.wine-guide-mobile {
    display: none;
}
.wine-guide-left {
    vertical-align: top;
    width: 224px;
    background: #ffffff;
    margin-right: 24px;
    border-radius: 16px;
    display: inline-block;
}

.wine-guide-right {
    vertical-align: top;
    display: inline-block;
    width: calc(100% - 252px);
    background: url('../assets/map.png') no-repeat center top;
    height: 451px;
    border-radius: 16px;
    background-size: cover;
}

.wine-guide-country {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #002840;
    padding: 8px 12px;
    height: 41px;
    display: block;
    text-decoration: none;
    line-height: 25px;
}

.wine-guide-country:hover {
    background: #E5EDF2;
}

.news-and-articles {
    padding: 80px 0;
}

.pp-wrapper {
    background: #f7f7f7;
}

.pp-wrapper .padding80 {
    padding-bottom: 50px;
}

.pp-text {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    color: #002840;
}

.pp-img {
    height: 383px;
    width: 100%;
    background: url("../assets/company/pp.png") no-repeat center;
    background-size: contain;
}

.tabs-title {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    color: #002840;
    margin-bottom: 8px;
}

.academy-expert-wrapper {
    height: 292px;
    padding: 80px 0;
    background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
}

.home-section10-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 12px;
}

.home-section10-subtitle {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 24px;
}

.home-section2-btn1 {
    padding: 8px 16px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    color: #ffffff;
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    text-decoration: none;
}

.home-section2-btn1:hover {
    cursor: pointer;
}

.home-section2-btn2 {
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #004F7F;
    border: 2px solid #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    height: 36px;
    margin-left: 12px;
    text-decoration: none;
}

.home-section2-btn1.btn-white {
    background: #ffffff;
    color: #004F7F;
}

.home-section2-btn2.border-white {
    border-color: white;
    color: white;
}

.wine-invest-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    color: #002840;
    margin-bottom: 40px;
}

.wine-invest-head {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #002840;
    padding-left: 80px;
    height: 56px;
    line-height: 56px;
}

.wine-invest-head1 {
    background: url("../assets/icons/wine-invest1.png") no-repeat 0 0;
    background-size: 56px;
}

.wine-invest-head2 {
    background: url("../assets/icons/wine-invest2.png") no-repeat 0 0;
    background-size: 56px;
}

.wine-invest-head3 {
    background: url("../assets/icons/wine-invest3.png") no-repeat 0 0;
    background-size: 56px;
}

.wine-invest-head4 {
    background: url("../assets/icons/wine-invest4.png") no-repeat 0 0;
    background-size: 56px;
}

.wine-invest-head5 {
    background: url("../assets/icons/wine-invest5.png") no-repeat 0 0;
    background-size: 56px;
}

.wine-invest-head6 {
    background: url("../assets/icons/wine-invest6.png") no-repeat 0 0;
    background-size: 56px;
}

.wine-invest-panel-content {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #002840;
    padding: 16px 0;
}

.wine-invest-panel-content ul {
    margin-top: 20px;
    margin-bottom: 20px;
}

.table-info {
    font-weight: bold;
    margin-top: 32px;
}

.table-head {
    background: #ccc;
    padding: 5px;
}

.table-row {
    padding: 3px;
    border-bottom: 1px solid #ccc;
}

.table-left, .table-right {
    display: inline-block;
}

.table-left {
    width: 100px;
}

.table-right {
    width: calc(100% - 104px);
}

.wine-expansion-panel {
    background: #FFFFFF;
    box-shadow: 0 4px 32px rgba(117, 102, 62, 0.32);
    border-radius: 16px;
    margin-bottom: 24px;
    border: 0;
}
.reg-container {
    margin-top: 16px;
}
.theme--light.v-btn.v-btn--has-bg.login-submit {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    gap: 8px;
    width: 382px;
    height: 40px;
    background: #004F7F;
    border-radius: 8px;
    margin-top: 24px;
}

.qr-popup.expert-popup.v-card {
    background: #f2f3f6;
    height: 630px;
}
.expert-popup iframe {
    width: 100%;
    height: 600px;
    border: 0;
    border-radius: 24px;
}

@media (max-width: 767px) {
    .padding200 {
        padding: 0 16px;
    }

    .padding80 {
        padding-top: 32px;
        padding-bottom: 32px;
    }

    .wine-guide-head .inner-page-title {
        padding-top: 100px;
        font-size: 18px;
        line-height: 22px;
    }

    .wine-guide-head .how-subheading {
        font-size: 16px;
        line-height: 20px;
    }

    .academy-expert-wrapper {
        padding: 32px 0;
        height: auto;
    }

    .news-and-articles {
        padding: 32px 0 0;
        height: auto;
    }

    h2 {
        font-size: 20px;
        line-height: 24px;
    }

    .blue-btn {
        width: 100%;
    }

    .wine-invest-title {
        font-size: 14px;
    }

    .wine-invest-head {
        font-size: 14px;
        line-height: 18px;
        padding-top: 10px;
        padding-left: 90px;
        padding-right: 20px;
    }

    .wine-guide-left {
        width: 100%;
        margin-right: 0;
        display: block;
    }
    .wine-guide-mobile {
        display: block;
        width: 100%;
        height: 200px;
        border-radius: 16px;
        background: #ffffff url('../assets/map.png') no-repeat center top;
        background-size: contain;
        margin-bottom: 16px;
    }
    .academy-container .wine-guide-right {
        display: none !important;
    }
    .pp-img {
        height: 200px;
    }
    .pp-wrapper .padding80 {
        padding-bottom: 32px;
    }
    ul.vindome-breadcrumbs {
        top: 90px;
    }
    .qr-popup.v-card.zoho-popup {
        width: 100%;
        height: auto;
    }
    .guide-content {
        background: #ffffff;
    }
    .guide-reg-wrapper,
    .theme--light.v-btn.v-btn--has-bg.login-submit {
        width: 100%;
    }
    .mobile-back {
        display: block;
        height: 177px;
        margin-top: 32px;
        margin-bottom: 32px;
        width: 100%;
        background: url("../assets/how/mobile_back.png") no-repeat right bottom;
    }
    .guide-title {
        width: calc(100% - 30px);
    }
    .home-section10 .container1366 {
        padding: 32px 0 0;
    }
    .home-section10-btn-wrapper {
        padding-right: 12px;
        padding-left: 12px;
    }
    .home-section10 .home-section2-btn1.btn-white {
        background: #004F7F;
        color: #ffffff;
    }
    .home-section10 .home-section2-btn2.border-white {
        color: #004F7F;
        border-color: #004F7F;
    }
    .home-section10-title2 {
        font-family: "Montserrat", Arial, Helvetica, sans-serif;
        font-style: normal;
        color: #FFFFFF;
        margin-bottom: 40px;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        margin-top: 0;
    }
    .home-section10-left {
        display: block;
        width: 100%;
        vertical-align: top;
        padding-right: 12px;
        padding-left: 12px;
        padding-top: 48px;
        height: auto;
        background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
    }
    .home-section10-right {
        display: inline-block;
        width: calc(50% - 2px);
        vertical-align: top;
        height: 341px;
    }
    .home-section10-left {
        display: block;
        width: 100%;
        vertical-align: top;
        padding-right: 12px;
        padding-left: 12px;
        padding-top: 24px;
        height: auto;
        background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
    }
    .home-section10-img {
        background: url("../assets/home/section10_en.png") no-repeat center;
        background-size: contain;
        width: 100%;
        height: 100%;
    }
    html[lang="de"] .home-section10-img {
        background: url("../assets/home/section10_de.png") no-repeat center;
        background-size: contain;
    }
    html[lang="it"] .home-section10-img {
        background: url("../assets/home/section10_it.png") no-repeat center;
        background-size: contain;
    }
    html[lang="fr"] .home-section10-img {
        background: url("../assets/home/section10_fr.png") no-repeat center;
        background-size: contain;
    }
    html[lang="ru"] .home-section10-img {
        background: url("../assets/home/section10_ru.png") no-repeat center;
        background-size: contain;
    }
    .home-section10-qr-wrapper,
    .home-section10-store-wrapper {
        display: flex;
        justify-content: space-between;
    }
    .home-section10-qr-wrapper {
        margin-bottom: 16px;
    }
    .home-section10-qr-wrapper svg,
    .home-section10-store-wrapper svg {
        margin-right: 0;
    }
    .home-section10-qr-wrapper > svg,
    .home-section10-store-wrapper > svg,
    .home-section10-qr-wrapper > a,
    .home-section10-store-wrapper > a {
        width: calc(100% / 2);
    }
    .home-section10-qr-wrapper a svg,
    .home-section10-store-wrapper a svg {
        margin: 0 auto 16px;
        display: block;
    }
    .home-section10-right {
        display: block;
        width: 100%;
        padding: 24px 12px;
        background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
    }
}
</style>

<style>
.theme--light.v-expansion-panels .v-expansion-panel.wine-expansion-panel:not(:first-child)::after {
    border: 0 !important;
}

.wine-academy-page .vueperslides--fixed-height .vueperslides__inner,
.wine-academy-page .vueperslides--fixed-height .vueperslides__parallax-wrapper {
    height: 470px;
    padding-bottom: 60px;
}

.wine-academy-page .vueperslides__bullets:not(.vueperslides__bullets--outside) {
    bottom: 10px;
}
.wine-academy-faq-tabs.theme--light.v-tabs > .v-tabs-bar,
.wine-academy-faq-tabs .theme--light.v-tabs-items,
.wine-academy-faq-tabs .v-card {
    background: #ffffff !important;
}

.wine-academy-faq-tabs .theme--light.v-tabs-items {
    max-width: 100%;
    padding: 0;
}

.wine-academy-faq-tabs .v-expansion-panel::before {
    box-shadow: none;
}

.wine-academy-faq-tabs .v-expansion-panel-header {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    color: #002840 !important;
    height: 40px;
    padding-left: 0;
    padding-right: 0;
}

.wine-academy-faq-tabs .theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
    color: #004F7F;
    font-size: 27px;
}

.wine-academy-faq-tabs.v-tabs--vertical > .v-tabs-bar .v-tab {
    padding: 8px 12px;
    height: 41px;
    background: #f7f7f7 !important;
    border-radius: 8px;
    margin-bottom: 8px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-transform: none;
    letter-spacing: normal;
    justify-content: flex-start;
}

.wine-academy-faq-tabs.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
    color: #002840 !important;
}

.wine-academy-faq-tabs.v-tabs--vertical > .v-tabs-bar .v-tab.v-tab--active {
    background: #004F7F !important;
    color: #ffffff !important;
}

.wine-academy-faq-tabs .v-tabs-slider-wrapper {
    display: none;
}

.wine-academy-faq-tabs.theme--light.v-tabs > .v-tabs-bar {
    width: 224px !important;
    flex: 1 0 auto;
    max-width: 100%;
}

.wine-academy-faq-tabs .v-card__text {
    padding: 0 0 0 24px;
}

.wine-academy-faq-tabs .theme--light.v-expansion-panels .v-expansion-panel {
    background: #ffffff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.16);
    border-radius: 0;
}

.how-it-works .header-toolbar {
    box-shadow: none;
}

.inner-page-app .hide-mobile {
    display: none;
}

.news-wrapper .vueperslide__content-wrapper.blog-img-layer {
    box-shadow: 0 4px 32px rgba(117, 102, 62, 0.32);
    border-radius: 16px;
}

.news-wrapper .vueperslides__track-inner {
    padding: 0 15px;
}

.news-wrapper .news-carousel-text-wrapper {
    width: 100%;
    height: calc(100% - 240px);
    padding: 16px 20px;
    text-align: left;
}

.news__title {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.88);
    height: 22px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.news__content {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.88);
    margin-top: 8px;
    margin-bottom: 24px;
}

a.news__button {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 8px 16px;
    gap: 8px;
    width: 142px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #ffffff;
    text-decoration: none;
}

.news-articles-carousel.vueperslides {
    max-width: 100%;
}

.news-articles-carousel:not(.vueperslides--slide-multiple) .vueperslide {
    transform: scale(.65);
    transition: .3s ease-in-out;
    border-radius: 16px;
    background-size: 260px;
    background-position-y: top;
}

.news-articles-carousel:not(.vueperslides--slide-multiple) .vueperslide--active {
    transform: scale(0.92);
    box-shadow: none;
    z-index: 1
}

.news-and-articles .vueperslides__bullet .default {
    width: 6px;
    height: 6px;
    border: 0;
    box-shadow: none;
    background: rgba(0, 0, 0, 0.16);
}

.news-and-articles .vueperslides__bullet--active .default {
    background: #E2C477;
    width: 8px;
    height: 8px;
}

.reg-container .flex {
    /*margin-top: 20px;*/
    text-align: left;
}

.reg-container .v-input--checkbox .v-input__slot {
    margin-bottom: 0;
}

.reg-container .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
}

.reg-container span {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: rgba(0, 0, 0, 0.64);
}

.reg-container .flex .v-text-field {
    padding-top: 0;
    margin-top: 0;
}

.reg-container .v-input input {
    height: 32px;
    max-height: unset;
    margin-top: 0;
    padding-left: 15px;
}

.reg-container .v-text-field .v-input__append-inner {
    margin-top: 0;
    background: #fff;
    height: 32px;
}

.reg-container .v-text-field .v-input__append-inner .v-input__icon {
    margin-top: 5px;
}

.reg-container .v-text-field .v-input__append-inner .primary--text {
    color: #000 !important;
    caret-color: #000 !important;
}

.reg-container .theme--light.v-input:not(.v-input--is-disabled) input {
    border: 0;
}

.reg-container .theme--light.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
    border-color: var(--brand);
}

.reg-container .theme--light.v-text-field > .v-input__control > .v-input__slot:after {
    border-color: rgba(0, 0, 0, .87);
    border-width: 1px;
}

.reg-container .theme--light.v-text-field.error--text > .v-input__control > .v-input__slot:after {
    border-color: #ff5252;
}

.reg-container .check-terms a {
    text-decoration: none;
    color: #707070;
    font-size: 19px;
    font-weight: 300;
}

.reg-container .v-input__slot {
    margin-bottom: 0;
}

.reg-container .check-terms a:hover {
    color: var(--brand);
}

.reg-container .v-input--checkbox label {
    font-size: 12px;
    line-height: 15px;
}

.reg-container .v-input--checkbox .v-messages {
    display: none;
}

.theme--light.v-btn.v-btn--has-bg.login-submit span {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
}

.wine-academy-page .vueperslides__arrow--prev {
    background: url("../assets/press_left.png") no-repeat center;
    background-size: contain;
    width: 38px;
    height: 37px;
}

.wine-academy-page .vueperslides__arrow--next {
    background: url("../assets/press_right.png") no-repeat center;
    background-size: contain;
    width: 38px;
    height: 37px;
}
.wine-academy-page .vueperslides__arrow--prev svg,
.wine-academy-page .vueperslides__arrow--next svg {
    display: none;
}

.wine-academy-page .news-wrapper .vueperslide__content-wrapper.blog-img-layer {
    background: white;
}

@media (min-width: 768px) {
    .wine-academy-page .news-articles-carousel:not(.vueperslides--slide-multiple) .vueperslide {
        left: -40%;
        opacity: 0.7;
    }
    .wine-academy-page .news-articles-carousel:not(.vueperslides--slide-multiple) .vueperslide--active {
        left: 0;
        opacity: 1;
    }
}

@media (max-width: 767px) {
    .how-it-works a.news__button,
    .how-it-works .home-section2-btn2.border-white,
    .how-it-works .home-section2-btn1.btn-white {
        display: block;
        width: 100%;
        margin-left: 0;
        text-align: center;
    }
    .home-section2-btn1.btn-white {
        margin-bottom: 16px;
    }
    .wine-academy-faq-tabs.theme--light.v-tabs > .v-tabs-bar {
        width: 100%;
    }

    .v-tabs.wine-academy-faq-tabs.v-tabs--vertical {
        display: block;
    }

    .wine-academy-faq-tabs .theme--light.v-tabs-items {
        margin-top: 32px;
    }

    .news__title {
        font-size: 16px;
        line-height: 20px;
    }

    .wine-academy-page .news__content {
        font-size: 14px;
        height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
    }

    .wine-academy-page .news-wrapper .vueperslides__track-inner {
        padding: 0 !important;
    }

    .wine-academy-page .news-articles-carousel.vueperslides {
        padding-bottom: 0 !important;
        height: auto !important;
    }

    .wine-academy-page .vueperslides--fixed-height .vueperslide {
        height: 410px;
        padding: 0;
    }

    .wine-academy-page .vueperslides__arrow--prev {
        left: 15px;
        width: 28px;
        height: 27px;
    }
    .wine-academy-page .vueperslides__arrow--next {
        right: 15px;
        width: 28px;
        height: 27px;
    }
    .slide-bg {
        background-position: center left;
    }
}
</style>
